import React from 'react';
import classNames from 'classnames';
import './button.css';

const Button = ({ onClick, disabled, children, noBackground }) => (
  <div
    onClick={!disabled && onClick}
    className={classNames(
      'button',
      disabled && 'disabled',
      noBackground && 'no-background'
    )}
  >
    {children}
  </div>
);

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/index.js